/**
 * Entry application component used to compose providers and render Routes.
 * */

import React from "react";
import {Provider} from "react-redux";
import {BrowserRouter} from "react-router-dom";
import {PersistGate} from "redux-persist/integration/react";
import {LayoutSplashScreen, MaterialThemeProvider} from "../_metronic/layout";
import MetaTags from "react-meta-tags";
import "swiper/swiper-bundle.min.css";
import {ErrorBoundary} from "react-error-boundary";
import AuthGate from "./wrappers/AuthGate";
import {ErrorFallback} from "./ErrorFallback";
import Routes from "./Routes";
import AlgoliaProvider from "./wrappers/AlgoliaProvider";

require("dotenv").config();

const {APP_ENV} = process.env.REACT_APP_APP_ENV;

export const DatabaseURL = process.env.REACT_APP_BACKEND_API_URL;

export default function App(props) {
    const {store, persistor, basename} = props;

    return (
        /* Provide Redux store */
        <Provider store={store}>
            {APP_ENV !== "prod" ? (
                <MetaTags>
                    <meta name="robots" content="noindex"/>
                </MetaTags>
            ) : null}
            {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
            <PersistGate persistor={persistor} loading={<LayoutSplashScreen/>}>
                {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
                <React.Suspense fallback={<LayoutSplashScreen/>}>
                    {/* Override `basename` (e.g: `homepage` in `package.json`) */}
                    <BrowserRouter basename={basename}>
                        {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
                        <MaterialThemeProvider>
                            <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => {}}>
                                <AuthGate>
                                    <AlgoliaProvider>
                                        <Routes/>
                                    </AlgoliaProvider>
                                </AuthGate>
                            </ErrorBoundary>
                        </MaterialThemeProvider>
                    </BrowserRouter>
                </React.Suspense>
            </PersistGate>
        </Provider>
    );
}
